import {getCookie, setCookie, isMob} from "../../_helpers";

const TIMEOUT = 50;
const SCROLL_OFFSET = isMob() ? 300 : 1000;
const COOKIE_NAME = 'uniqueСlient';
const COOKIE_DAYS_LIVE = 5;
const YA_TARGET_NAME = 'key';
const GA_TARGET_NAME = 'key';

export function watch() {

    if(getCookie(COOKIE_NAME)) return false;

    var wasScroll = false;
    var wasWatch = false;

    window.addEventListener('scroll', () => {
        if(!wasScroll && (window.scrollY > SCROLL_OFFSET)){
            wasScroll = true;
            checkWas();
        }
    });

    setTimeout( () => {
        wasWatch = true;
        checkWas();
    }, TIMEOUT * 1000);

    function checkWas() {
        if(wasScroll && wasWatch){
            setCookie(COOKIE_NAME, (new Date()).getTime(), COOKIE_DAYS_LIVE);

            if(typeof ga !== 'undefined'){
                ga("send", "event", GA_TARGET_NAME, "goal", "visitor")
            }

            if(yaCounterId !== undefined && yaCounterId != null) {
                window['yaCounter'+yaCounterId].reachGoal(YA_TARGET_NAME);
            }
        }
    }
}

